/**
 * Hero3DCar — wrapper that ties scroll progress to car rotation
 * and lazy-loads the Three.js scene.
 */
import React, { useRef, useState } from "react";
import { useScroll, useTransform, useMotionValueEvent } from "framer-motion";
import ThreeScene from "./ThreeScene";

function FallbackImage() {
    return (
        <div className="absolute inset-0 grid place-items-center">
            <img
                src="https://images.unsplash.com/photo-1614949194403-9602bdc14a3a?w=1600&q=85"
                alt="F1 car"
                className="max-w-[80%] max-h-[70%] object-contain opacity-90"
            />
        </div>
    );
}

export default function Hero3DCar({ scrollTarget }) {
    const { scrollYProgress } = useScroll({
        target: scrollTarget,
        offset: ["start start", "end start"],
    });
    const rotationY = useTransform(scrollYProgress, [0, 1], [0, Math.PI * 0.62]);
    const rotationRef = useRef(0);
    useMotionValueEvent(rotationY, "change", (v) => {
        rotationRef.current = v;
    });

    const [hasError] = useState(false);

    if (hasError) {
        return (
            <div className="absolute inset-0 pointer-events-none" data-testid="hero-3d-fallback">
                <FallbackImage />
            </div>
        );
    }

    return (
        <div className="absolute inset-0 pointer-events-none" data-testid="hero-3d-car">
            <ThreeScene rotationRef={rotationRef} />
        </div>
    );
}
